/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcPaymentsV1IncomingAchEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_PAYMENTS_V1_INCOMING_ACH_EVENT_ENTITY_NAME = 'ixc.payments.v1.IncomingAchEvent';
export const ixcPaymentsV1IncomingAchEventEntity = new schema.Entity<IxcPaymentsV1IncomingAchEvent>(IXC_PAYMENTS_V1_INCOMING_ACH_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxcPaymentsV1IncomingAchEvent) => `${entity.metadata?.eventId}` });

